var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.578 120.863C130.866 127.357 155.343 134.782 159.24 127.409C163.136 120.035 143.214 103.994 130.925 97.4999C118.637 91.0052 96.3856 84.7567 92.4888 92.1298C88.592 99.5028 106.289 114.368 118.578 120.863Z",
    fill: "#D57A66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2909 130.442C88.8749 144.098 98.3311 167.864 106.525 166.313C114.719 164.763 114.839 139.186 112.255 125.529C109.671 111.872 100.683 90.5793 92.4889 92.1297C84.2948 93.6801 83.7069 116.785 86.2909 130.442Z",
    fill: "#D57A66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.671 111.171C49.6048 121.706 36.92 143.917 43.2411 149.356C49.5622 154.796 69.6342 138.943 78.7004 128.408C87.7667 117.872 98.8099 97.5693 92.4888 92.1296C86.1677 86.6898 67.7373 100.636 58.671 111.171Z",
    fill: "#D57A66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5168 77.5615C42.6273 77.0418 17.3535 80.9726 17.0417 89.3063C16.7299 97.6399 41.6393 103.448 55.5287 103.968C69.4182 104.488 92.1771 100.463 92.4889 92.1293C92.8007 83.7956 70.4062 78.0812 56.5168 77.5615Z",
    fill: "#D57A66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4502 54.9224C73.1966 43.7391 54.3654 26.4301 47.6555 31.3822C40.9456 36.3344 51.9351 59.4308 60.1887 70.6141C68.4423 81.7973 85.779 97.0815 92.4889 92.1294C99.1989 87.1772 89.7038 66.1056 81.4502 54.9224Z",
    fill: "#D57A66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.696 60.3007C118.293 46.8751 120.085 21.3603 112.03 19.2019C103.974 17.0434 92.7687 40.0358 89.1714 53.4614C85.574 66.887 84.4335 89.9708 92.4889 92.1293C100.544 94.2877 111.099 73.7262 114.696 60.3007Z",
    fill: "#D57A66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.219 89.6472C143.959 84.089 165.024 69.5816 161.689 61.938C158.354 54.2943 133.391 59.8689 120.652 65.4271C107.913 70.9852 89.1538 84.4862 92.4887 92.1298C95.8236 99.7735 118.48 95.2054 131.219 89.6472Z",
    fill: "#D57A66"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4682,
    cy: 92.4682,
    rx: 16.1733,
    ry: 16.1733,
    transform: "rotate(15 92.4682 92.4682)",
    fill: "#C58BF1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, "D57A66\n", _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.064 99.1111C101.81 98.507 100.866 94.7182 100.866 94.7182C100.866 94.7182 103.578 91.9088 105.832 92.5129C108.087 93.117 115.562 98.656 115.562 98.656C115.562 98.656 106.319 99.7152 104.064 99.1111Z",
    fill: "#D57A66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9705 105.365C94.8034 103.344 96.8153 99.9973 96.8153 99.9973C96.8153 99.9973 100.719 99.9282 101.886 101.95C103.053 103.971 104.422 113.173 104.422 113.173C104.422 113.173 97.1375 107.386 95.9705 105.365Z",
    fill: "#D57A66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8252 104.064C86.4293 101.81 90.2181 100.866 90.2181 100.866C90.2181 100.866 93.0275 103.578 92.4234 105.832C91.8193 108.087 86.2803 115.562 86.2803 115.562C86.2803 115.562 85.2211 106.319 85.8252 104.064Z",
    fill: "#D57A66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5713 95.9705C81.5927 94.8035 84.939 96.8153 84.939 96.8153C84.939 96.8153 85.0081 100.719 82.9868 101.886C80.9654 103.053 71.763 104.423 71.763 104.423C71.763 104.423 77.5499 97.1376 79.5713 95.9705Z",
    fill: "#D57A66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8723 85.8252C83.1269 86.4293 84.0705 90.2181 84.0705 90.2181C84.0705 90.2181 81.3589 93.0275 79.1043 92.4234C76.8498 91.8193 69.3746 86.2803 69.3746 86.2803C69.3746 86.2803 78.6178 85.2211 80.8723 85.8252Z",
    fill: "#D57A66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.966 79.5714C90.1331 81.5928 88.1212 84.9392 88.1212 84.9392C88.1212 84.9392 84.2173 85.0083 83.0502 82.9869C81.8832 80.9655 80.514 71.7631 80.514 71.7631C80.514 71.7631 87.799 77.5501 88.966 79.5714Z",
    fill: "#D57A66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1113 80.8725C98.5072 83.127 94.7183 84.0707 94.7183 84.0707C94.7183 84.0707 91.909 81.359 92.5131 79.1045C93.1172 76.8499 98.6561 69.3747 98.6561 69.3747C98.6561 69.3747 99.7154 78.6179 99.1113 80.8725Z",
    fill: "#D57A66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.365 88.9659C103.344 90.133 99.9974 88.1211 99.9974 88.1211C99.9974 88.1211 99.9284 84.2172 101.95 83.0501C103.971 81.8831 113.173 80.5139 113.173 80.5139C113.173 80.5139 107.387 87.7989 105.365 88.9659Z",
    fill: "#D57A66"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.c5336ef7287e1f11585e69a2dd33d03c.svg";
export { ForwardRef as ReactComponent };